import { useState } from "react"

import { useFormSections, useFields } from "web/hooks/data"
import { useCurrentTLO } from "web/hooks/context"

import { ContentBox, Toggle } from "web/components"

import ViewOrEdit from "./ViewOrEdit"

function getFieldsWithStageStatus(fields, missingStageFields) {
  if (!missingStageFields) {
    missingStageFields = []
  }

  return fields.map((field) => {
    const matchingStageField = missingStageFields.find(
      (msf) => msf.field.id === field.id
    )

    const isRequired = matchingStageField !== undefined

    return {
      ...field,
      isOptionalRequired: isRequired && !matchingStageField.mandatory,
      isMandatoryRequired: isRequired && matchingStageField.mandatory,
    }
  })
}

export default function ViewOrEditTLO({
  excludedFieldIds = [],
  supportsMissingStageFields = false,
}) {
  const [fieldFilter, setFieldFilter] = useState("")
  const [showAllFields, setShowAllFields] = useState({ value: false })

  const { subjectType, data, userCan } = useCurrentTLO()
  const fields = useFields({ subjectType })
  const sections = useFormSections({ subjectType })
  const userCanUpdate = userCan("update")

  const { missing_stage_fields: missingStageFields } = data

  async function handleFieldChange(update) {
    const valueBlob = (x) => ({ value: x, form_value: x })

    const formattedUpdate = Object.keys(update).reduce(
      (result, key) => ({ ...result, [key]: valueBlob(update[key]) }),
      {}
    )

    // newLocalData is used to local mutate swr and avoid
    // API call roundtrip slowing down update in UI
    const newLocalData = {
      ...data,
      values: { ...data.values, ...formattedUpdate },
    }
    data.update(update, newLocalData)
  }

  function handleLoadEmpty() {
    if (userCanUpdate) setShowAllFields({ value: true })
  }

  const editableFields = fields.filter((f) => !excludedFieldIds.includes(f.id))
  const decoratedFields = getFieldsWithStageStatus(
    editableFields,
    missingStageFields
  )

  return (
    <>
      <div className="view-or-edit-tlo-tools">
        {userCanUpdate && (
          <div className="view-or-edit-show-all-fields">
            <Toggle
              label="Show All Fields"
              checked={showAllFields.value}
              onClick={() => setShowAllFields({ value: !showAllFields.value })}
            />
          </div>
        )}
        <div className="view-or-edit-quick-filter">
          <input
            value={fieldFilter}
            placeholder="Search fields..."
            onChange={(e) => setFieldFilter(e.target.value)}
          />
        </div>
      </div>
      <ContentBox>
        <ViewOrEdit
          missingStageFields={missingStageFields}
          supportsMissingStageFields={supportsMissingStageFields}
          data={data}
          fields={decoratedFields}
          fieldFilter={fieldFilter}
          sections={sections}
          showAll={showAllFields.value}
          readOnly={!userCanUpdate}
          onFieldChanged={handleFieldChange}
          onLoadedEmpty={handleLoadEmpty}
        />
      </ContentBox>
    </>
  )
}
